import { foreignSupportAddressNameFields } from 'constants/enums/people';
import { ValidateJSModel } from 'forms/shared/types';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { hasYesOrNo } from 'models/validate';
import { ForeignActivitiesSupportModel } from './types';
import { foreignActivitiesSupportItemValidator } from './validators/item';

const foreignActivitiesSupportValidator: ValidateJSModel<ForeignActivitiesSupportModel> = {
  HasForeignSupport: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes, attributeName, options) => {
    if (attributes?.HasForeignSupport?.value === 'Yes') {
      let additionalValidation: any = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, foreignSupportAddressNameFields);

      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.relatives.error.duplicateListItems',
          }
        };
      }

      return {
        ...additionalValidation,
        presence: true,
        accordion: { validator: foreignActivitiesSupportItemValidator },
      };
    }

    return {};
  },
};
export default foreignActivitiesSupportValidator;
